import React from "react";
import PropTypes from "prop-types";
import ConnectedP2PInjection from "./ConnectedP2PInjection";

const P2PRegistrationInjection = ({ appLoading, dataLocation }) => {
    return !appLoading && <ConnectedP2PInjection dataLocation={dataLocation} />;
};

P2PRegistrationInjection.propTypes = {
    appLoading: PropTypes.bool.isRequired,
    // Denotes which injection container should get the data
    dataLocation: PropTypes.oneOf(["header", "footer"]),
};

export default P2PRegistrationInjection;
